import { Routes } from '@angular/router';
import { sessionGuard } from './guards/session.guard';
import { authRoutes } from './pages/auth/auth.routes';
import { dashboardRoutes } from './pages/dashboard/dashboard.routes';
import { paymentGatewayRoutes } from './pages/payment-gateway/payment-gateway.routes';
import { publicRoutes } from './pages/public/public.routes';

export const routes: Routes = [
  {
    canActivate: [sessionGuard],
    children: authRoutes,
    path: 'auth',
  },
  {
    canActivate: [sessionGuard],
    children: dashboardRoutes,
    path: 'dashboard',
  },
  {
    children: paymentGatewayRoutes,
    path: 'payment-gateway',
  },
  {
    children: publicRoutes,
    path: 'public',
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'dashboard',
  },
];
